import { nullish } from 'shared-utils/data';
import { isPathWithin } from 'shared-utils/file';

import { StorageLocation } from '../../communication';

export function getStorageLocationPath(storageLocation: StorageLocation, rootPath: string | undefined): string {
  if (nullish(rootPath)) {
    return storageLocation.path;
  }

  return isPathWithin(storageLocation.path, rootPath)
    ? rootPath
    : storageLocation.path;
}

export function isWithinRootPathScope(storageLocation: StorageLocation, rootPath: string | undefined): boolean {
  if (nullish(rootPath)) {
    return true;
  }

  return isPathWithin(storageLocation.path, rootPath);
}
